export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7222.b80a08e9.jpg";